import { ActionClass } from '@platform-frontend/util';
import { ActionFilter } from './action-filter';

export class ExclusiveActionFilter implements ActionFilter {
  constructor(...actions: ActionClass[]) {
    this.actions = new Set(actions);
  }

  private actions: Set<ActionClass>;

  matchesAny(actions: ActionClass[]): boolean {
    return actions.some(pendingAction => !this.actions.has(pendingAction));
  }
}
